const filterData = (() => {
  const replaceAt = (str, index, ch) => {
    return str.replace(/./g, (c, i) => (i == index ? ch : c));
  };

  const excludeKey = (key) => {
    const allowedKeys = [
      "source",
      "attribute_id",
      "cart_item_id",
      "description",
    ];
    return key.includes("date") || allowedKeys.includes(key);
  };

  const anonymiseString = (text) => {
    const parts = text.split(" ");
    for (var p in parts) {
      if (parts.hasOwnProperty(p)) {
        for (let i = 1; i <= parts[p].length; i++) {
          if (parts[p][i] === "@") {
            break;
          }
          parts[p] = replaceAt(parts[p], i, "*");
        }
      }
    }

    return parts.join(" ");
  };

  const analyseData = (data) => {
    for (var k in data) {
      if (data.hasOwnProperty(k)) {
        if (excludeKey(k)) {
          continue;
        }

        if (typeof data[k] == "string") {
          data[k] = anonymiseString(data[k]);
          continue;
        }

        data[k] = analyseData(data[k]);
      }
    }
    return data;
  };

  return {
    filter: (text) => {
      try {
        return JSON.stringify(analyseData(JSON.parse(text)));
      } catch (e) {
        return "{}";
      }
    },
  };
})();

export default filterData;
